import { Checkbox, DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutAgedARReport extends Layout {
    checkboxCustomerPage: Checkbox;
    checkboxUserPage: Checkbox;
    excludabletextboxA: ExcludableTextbox;
    excludabletextboxC: ExcludableTextbox;
    excludabletextboxCat: ExcludableTextbox;
    excludabletextboxS: ExcludableTextbox;
    sourceAgedAR: DataSource;
    switchGL: Switch;
    switchGroupBy: Switch;
    switchIncludeOpenCredits: Switch;
    switchPastDue: Switch;
    switchPrintBOL: Switch;
    switchSortBy: Switch;
    switchUserType: Switch;
    textboxAgeDate: Textbox;
    textboxCallHistory: Textbox;
    textboxCurrency: Textbox;
    textboxHierarchyCode: Textbox;
    textboxHierarchyGroupBy: Textbox;
    textboxHierarchyLevel: Textbox;
    textboxInvoiceCutoff: Textbox;
    textboxPaymentCutoff: Textbox;
    textboxReportBy: Textbox;
    textboxReportType: Textbox;
}
